import { render, staticRenderFns } from "./FacialRecognitionInstructionModal.vue?vue&type=template&id=a56ec7a0&scoped=true&"
import script from "./FacialRecognitionInstructionModal.vue?vue&type=script&lang=js&"
export * from "./FacialRecognitionInstructionModal.vue?vue&type=script&lang=js&"
import style0 from "./FacialRecognitionInstructionModal.vue?vue&type=style&index=0&id=a56ec7a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56ec7a0",
  null
  
)

export default component.exports